import { render, staticRenderFns } from "./edit-customer-sale.vue?vue&type=template&id=de13b902&"
import script from "./edit-customer-sale.vue?vue&type=script&lang=js&"
export * from "./edit-customer-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports